export const RESOURCE_FILTERS = Object.freeze([
  { key: 'all', label: 'All' },
  { key: 'api', label: 'APIs' },
  { key: 'data', label: 'Data feeds' },
  { key: 'evidence', label: 'Evidence' },
  { key: 'licensing', label: 'Licensing' },
  { key: 'infrastructure', label: 'Infrastructure' },
]);

export const RESOURCE_AREAS = Object.freeze([
  {
    key: 'licensing',
    label: 'Licensing',
    detail: 'Renewals, true-ups, entitlements',
    tone: 'blue',
  },
  {
    key: 'infrastructure',
    label: 'Infrastructure',
    detail: 'Cloud, hosting, network dependencies',
    tone: 'sage',
  },
  {
    key: 'risk',
    label: 'Risk',
    detail: 'Register signals tied back to products',
    tone: 'amber',
  },
  {
    key: 'manpower',
    label: 'Manpower',
    detail: 'Personnel, training, org alignment',
    tone: 'blue',
  },
  {
    key: 'admin',
    label: 'Administrative',
    detail: 'Taskers, routing, review timelines',
    tone: 'sage',
  },
  {
    key: 'contracting',
    label: 'Contracting',
    detail: 'Options, deliverables, obligation timing',
    tone: 'amber',
  },
]);

function textFor(record) {
  return Object.values(record || {})
    .flatMap((value) => (Array.isArray(value) ? value : [value]))
    .filter((value) => value != null && typeof value !== 'object')
    .join(' ')
    .toLowerCase();
}

export function resourceKindForRecord(record) {
  const text = textFor(record);
  if (/license|entitlement|true.?up/.test(text)) return 'licensing';
  if (/aws|cloud|host|network|infra|environment/.test(text)) return 'infrastructure';
  if (/artifact|evidence|brief|charter|smp|document/.test(text)) return 'evidence';
  if (/api|jira|servicenow|ado|endpoint|webhook/.test(text)) return 'api';
  return 'data';
}

export function filterResourceRecords(records, filterKey) {
  const list = Array.isArray(records) ? records : [];
  if (!filterKey || filterKey === 'all') return list;
  return list.filter((record) => resourceKindForRecord(record) === filterKey);
}

export function buildResourceEcosystemSummary(connectors = [], { auditCount = null } = {}) {
  const total = connectors.length;
  const attention = connectors.filter((connector) =>
    /warn|error|fail|degraded/i.test(connector.status || ''),
  ).length;
  const healthy = Math.max(total - attention, 0);
  const apiLike = connectors.filter(
    (connector) => resourceKindForRecord(connector) === 'api',
  ).length;

  return [
    {
      id: 'ecosystem-feeds',
      label: 'Simulated feeds',
      value: total || '—',
      detail: total
        ? `${healthy} prototype adapters ready, ${attention} need attention`
        : 'Prototype adapter inventory ready',
      tone: attention ? 'amber' : 'sage',
    },
    {
      id: 'ecosystem-apis',
      label: 'Prototype API adapters',
      // Real classification only — zero renders as zero (AC-TRUST-2).
      value: apiLike,
      detail: 'Simulated source-to-PRIME handoffs',
      tone: 'blue',
    },
    {
      id: 'ecosystem-audit',
      label: 'Audit trail',
      value: auditCount == null ? '—' : auditCount,
      detail:
        auditCount == null
          ? 'Recent prototype data-domain activity'
          : 'Recent simulation, lineage, and reconciliation events',
      tone: 'sage',
    },
    {
      id: 'ecosystem-areas',
      label: 'Resource areas',
      value: RESOURCE_AREAS.length,
      detail: 'Licensing, infra, risk, manpower, admin, contracting',
      tone: 'amber',
    },
  ];
}
